// extracted by mini-css-extract-plugin
export default {"btop":"d28a6a82cc a5ae072152 _71bd27f9c4","icon":"ae0ec93710 _8698cdbf74","btoppink":"f90c22a242 ecf567d09d"};